import React from 'react'
import LoginForm from '../../Components/Forms/LoginForm/LoginForm'

const login = () => {
  return (
    <div className='pageHolder bg-black'>
        <LoginForm/>
    </div>
  )
}

export default login